import React from "react";
import team_work from "../Assets/images/team_work.png"
import CountUp from "react-countup";
import { DoubleArrow } from "@mui/icons-material";
import { title } from "../config/Config";
import Marquee from "react-fast-marquee";
import star from "../Assets/images/star.png"

const About = () => {
  return (
    <div>
      <div className="about-sec">
        <div className="top-sec">
          <div className="container-layout">
            <div className="inner-info">
              <span>GSI</span>
              <h4>Who we are</h4>
              <h1>ABOUT US</h1>
          
            </div>
          </div>
        </div>
        <div className="sec-sec">
          <div className="container-layout">
            <div className="inner-content">
              <div className="info">
                <h2> Gs Infotech </h2>
                <p>
                  {title} are a full-fledged company offering digital
                  marketing solutions that range from web designing, web
                  development, SEO, testing, to digital marketing. We are also
                  known as a top-rated web solution company, which is imparted by
                  qualities and proficiency. We have a huge and robust network of
                  designers, developers, SEO executives, and testers, delivering
                  quality work and outcomes in the end.
                </p>
                <p>
                  We are known for quality work because of our expertise in
                  different fields. We have given our digital marketing services
                  to a wide range of clients from different parts of India and
                  even, overseas. Our clients are completely happy and contented
                  with our services. We have made our strong existence in
                  different fields like web designing, website or app development,
                  SEO optimization, testing, online marketing, and many others.
                  Not only this, we utilize our aptitude to meet our goals, which
                  are related to creativity, adjustability, intellectuality, and
                  success.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="third-sec">
          <div className="container-layout">
            <div className="row justify-content-between">
              <div className="col-lg-6 left">
                <div className="inner"></div>
                <div className="for-hide">
                  <div className="inner_card inner_card_1">
                    <DoubleArrow />
                    <h5>Discussion</h5>
                  </div>
                  <div className="inner_card inner_card_2">
                    <DoubleArrow />
                    <h5>Planning</h5>
                  </div>
                  <div className="inner_card inner_card_3">
                    <DoubleArrow />
                    <h5>Designing</h5>
                  </div>
                  <div className="inner_card inner_card_4">
                    <DoubleArrow />
                    <h5>Developing</h5>
                  </div>
                  <div className="inner_card inner_card_5">
                    <DoubleArrow />
                    <h5>Testing</h5>
                  </div>
                  <div className="inner_card inner_card_6">
                    <DoubleArrow />
                    <h5>Delivering</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 d-flex align-items-center justify-content-start">
                <div className="inner-content">
                  {/* <span>/ /</span> */}
                  <span className="preheading mb-3"> OFFERS</span>
                  <h1>What do we offer?</h1>
                  <h6 className="mb-4">Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt</h6>
                  <p>
                    These days, creating an online business or maintaining it
                    according to the latest tools and technologies is not a
                    simple job, but we have made it true for all of our clients.
                    We assist a business to show their work via websites or
                    other online systems. We are also proficient in making the
                    websites that show or speak about the brand clearly.
                    Additionally, giving identity to a business online is our
                    motto. This is where our creativity comes into existence.
                  </p>
                  <p>
                    We start working on every project of our clients after
                    realizing the requirements, scope, purpose, and objectives.
                    We follow a step-by-step procedure to finish every project,
                    which is mentioned below:
                  </p>
                  <div className="row">

                    <div className="col-sm-6 for-show">
                      <div className="inner_card inner_card_1">
                        <DoubleArrow />
                        <h5>Discussion</h5>
                      </div>
                    </div>
                    <div className="col-sm-6 for-show">
                      <div className="inner_card inner_card_2">
                        <DoubleArrow />
                        <h5>Planning</h5>
                      </div>
                    </div>
                    <div className="col-sm-6 for-show">
                      <div className="inner_card inner_card_3">
                        <DoubleArrow />
                        <h5>Designing</h5>
                      </div>
                    </div>
                    <div className="col-sm-6 for-show">
                      <div className="inner_card inner_card_4">
                        <DoubleArrow />
                        <h5>Developing</h5>
                      </div>
                    </div>
                    <div className="col-sm-6 for-show">
                      <div className="inner_card inner_card_5">
                        <DoubleArrow />
                        <h5>Testing</h5>
                      </div>
                    </div>
                    <div className="col-sm-6 for-show">
                      <div className="inner_card inner_card_6">
                        <DoubleArrow />
                        <h5>Delivering</h5>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="marque-sec">
          <div className="inner_content">
            <Marquee>
              <h1>Design</h1>
              <img className="star" src={star} alt="" />
              <h1>Figma Design</h1>
              <img className="star" src={star} alt="" />
              <h1>Web Solution</h1>
              <img className="star" src={star} alt="" />
            </Marquee>
          </div>
        </div>
        <div className="forth-sec">
          <div className="container-layout">
            <div className="inner-content">
              {/* <h2>
                Reach us for a sturdy online reputation, visibility, branding,
                and existence!
              </h2> */}
              <div className="row for_driction">
                <div className="col-md-6 d-flex align-items-center justify-content-start">
                  <div className="">
                    <p><span>/ /</span> TECHNOLOGY INDEX</p>
                    <h1>Improve and Innovate with {title}</h1>
                    <h5>Reach us for a sturdy online reputation, visibility, branding, and existence!</h5>
                    <div className="wrapper">
                      <div className="progress_bar">
                        <div className="info d-flex align-items-center justify-content-between">
                          <h5 className="m-0">WordPress</h5>
                          <p className="m-0">90%</p>
                        </div>
                        <div className="progress-bar">
                          <div className="progress fill-1">
                            <div className="glow"></div>
                          </div>
                        </div>
                      </div>

                      <div className="progress_bar">
                        <div className="info d-flex align-items-center justify-content-between">
                          <h5 className="m-0">Web design</h5>
                          <p className="m-0">95%</p>
                        </div>
                        <div className="progress-bar">
                          <div className="progress fill-2">
                            <div className="glow"></div>
                          </div>
                        </div>
                      </div>

                      <div className="progress_bar">
                        <div className="info d-flex align-items-center justify-content-between">
                          <h5 className="m-0">Digital Marketing</h5>
                          <p className="m-0">98%</p>
                        </div>
                        <div className="progress-bar">
                          <div className="progress fill-3">
                            <div className="glow"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="right">
                    <img src={team_work} alt="" />
                  </div>
                </div>
              </div>
              {/* <div className="set-size charts-container">
                <div className="cover">
                  <div className="pie-wrapper progress-30">
                    <span className="label">
                      90<span className="smaller">%</span>
                    </span>
                    <div className="pie">
                      <div className="left-side half-circle"></div>
                      <div className="right-side half-circle"></div>
                    </div>
                  </div>
                  <h3>WordPress</h3>
                </div>
                <div className="cover">
                  <div className="pie-wrapper progress-60">
                    <span className="label">
                      95<span className="smaller">%</span>
                    </span>
                    <div className="pie">
                      <div className="left-side half-circle"></div>
                      <div className="right-side half-circle"></div>
                    </div>
                  </div>
                  <h3>Web design</h3>
                </div>
                <div className="cover">
                  <div className="pie-wrapper progress-90">
                    <span className="label">
                      98<span className="smaller">%</span>
                    </span>
                    <div className="pie">
                      <div className="left-side half-circle"></div>
                      <div className="right-side half-circle"></div>
                    </div>
                  </div>
                  <h3>Digital Marketing</h3>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="fifth-sec">
          <div className="container-layout">
            <div className="inner-content">
              <h1>
                About The <span>Company</span>
              </h1>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a more-or-less
                normal distribution of letters, as opposed to using ‘Content
                here, content here’, making it look like readable English. Many
                desktop
              </p>
            </div>
          </div>
        </div>
        <div className="counter-sec">
          <div className="container-layout">
            <div className="row">
              <div className="col-md-6 p-0">
                <div className="inner-content border_inner_1">
                  <div className="inner">
                    <h1 className="back">
                      <CountUp delay={1} end={1500} />+{" "}
                    </h1>
                    <h4>Happy Customers</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-6 p-0">
                <div className="inner-content border_inner_2">
                  <div className="inner">
                    <h1 className="back">
                      <CountUp delay={1} end={100} />%{" "}
                    </h1>
                    <h4>Service Guarante</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-6 p-0">
                <div className="inner-content border_inner_3">
                  <div className="inner">
                    <h1 className="back">
                      <CountUp delay={1} end={30} />+{" "}
                    </h1>
                    <h4>Cleaners</h4>
                  </div>
                </div>
              </div>
              <div className="col-md-6 p-0">
                <div className="inner-content border_inner_4">
                  <div className="inner">
                    <h1 className="back">
                      <CountUp delay={1} end={1000} />+{" "}
                    </h1>
                    <h4>Cleans Completed</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
